var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mural-selector-container"},[_c('h5',{staticClass:"subsection-header"},[_vm._v("All murals")]),_c('v-row',_vm._l((_vm.murals),function(mural,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('mural-card',{attrs:{"mural":mural,"onMuralSelect":_vm.onMuralSelect}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }